export const apiPredict = 'https://mal-api.vitalify.asia/predict';
